import * as Sentry from '@sentry/react'
import type { Event, EventHint } from '@sentry/types'
import { API } from 'aws-amplify'

import EnvironmentUtils from '@utils/environments'

/**
 * Sentry beforeSend handler to filter out cancelled requests and add extra data
 */
export function handleSentryBeforeSend(
  event: Event,
  hint: EventHint
): Event | null {
  if (API.isCancel(hint?.originalException)) {
    return null
  }

  // Add version as extra data
  event.extra = {
    ...event.extra,
    appVersion: process.env.REACT_APP_VERSION,
  }

  return event
}

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  integrations: [
    Sentry.replayIntegration({
      minReplayDuration: 1_000,
      flushMinDelay: 3_000,
      flushMaxDelay: 3_000,
      maskAllText: false,
      blockSelector:
        'iframe[name*="stripe"], iframe[name*="Stripe"], iframe[src*="js.stripe.com"], iframe[src*="checkout.stripe.com"]',
      networkDetailAllowUrls: [
        /^https:\/\/api\.technologymatch\.com\/api/,
        /^https:\/\/chat\.stream-io-api\.com/,
        /^https:\/\/api\.hubapi\.com/,
      ],
    }),
  ],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_SENTRY_ENVIRONMENT}`,
  enabled: (process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'local') !== 'local',
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: EnvironmentUtils.isProduction() ? 1.0 : 0,
  beforeSend: handleSentryBeforeSend,
  ignoreErrors: ['Non-Error promise rejection captured'],
})
